import { useEffect, useState } from 'react'

const FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

const INTENT_COLORS = {
  purchase: '#10b981',
  explore: '#6366f1',
  navigate: '#6366f1',
  info: '#8b5cf6',
  soft_exit: '#f59e0b',
}

function intentColor(intent) {
  return INTENT_COLORS[intent] || '#94a3b8'
}

export default function ActionList({ actions = [], visible, onSelect }) {
  const [mounted, setMounted] = useState(false)
  const [exiting, setExiting] = useState(false)

  useEffect(() => {
    if (visible && !mounted) {
      setExiting(false)
      setMounted(true)
    }
    if (!visible && mounted) {
      setExiting(true)
      const t = setTimeout(() => {
        setMounted(false)
        setExiting(false)
      }, 240)
      return () => clearTimeout(t)
    }
  }, [visible])

  if (!mounted || !actions.length) return null

  const wrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    marginBottom: 10,
    transition: 'opacity 0.24s ease, transform 0.24s ease',
    opacity: exiting ? 0 : 1,
    transform: exiting ? 'translateY(6px)' : 'translateY(0)',
    animation: !exiting ? 'aa-list-in 0.24s ease forwards' : undefined,
  }

  const rowStyle = (hovered) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    background: hovered ? '#f8fafc' : '#ffffff',
    borderRadius: 12,
    padding: '10px 14px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.09)',
    cursor: 'pointer',
    fontFamily: FONT,
    fontSize: 13,
    color: '#1a1a2e',
    transition: 'background 0.15s ease',
    userSelect: 'none',
  })

  return (
    <>
      <style>{`
        @keyframes aa-list-in {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div style={wrapperStyle}>
        {actions.map((action, i) => (
          <ActionRow key={i} action={action} onSelect={onSelect} rowStyle={rowStyle} />
        ))}
      </div>
    </>
  )
}

function ActionRow({ action, onSelect, rowStyle }) {
  const [hovered, setHovered] = useState(false)
  const color = intentColor(action.intent)

  return (
    <div
      style={rowStyle(hovered)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onSelect?.(action)}
    >
      <span style={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: color,
        flexShrink: 0,
      }} />
      <span style={{ flex: 1 }}>{action.label ?? action}</span>
      <span style={{ color: '#94a3b8', fontSize: 16, lineHeight: 1 }}>›</span>
    </div>
  )
}
